import {Component, EventEmitter, Input, Output} from '@angular/core';
import { GroupEnum } from 'src/app/shared/enums/group.enum';

interface FlowPerTrack {
  trackLabel: string;
  lastFlow: string | null;
}

@Component({
  selector: 'real-time-info-window-text',
  templateUrl: './info-window-text.component.html',
  styleUrls: ['./info-window-text.component.scss']
})
export class InfoWindowTextComponent {
  @Input() data: any = {};
  @Output() locationClick = new EventEmitter<any>();
  taxa = '';
  GroupEnum = GroupEnum

  // Controla a exibição do detalhamento de passagem por pista
  showFlowPerTrack = false;

  constructor() { }

  /**
   * Última passagem por pista, vinda do endpoint `getDeviceMetricsbyId`
   * (DEVICE_METRICS_ID), no campo `flowPerTrack`.
   */

  get equipmentAvailability(): number | string {
    return this.data?.availabilityPercentage ?? '';
  }

  get ocrEquipmentReading(): number | string {
    return this.data?.ocrMetric ?? '';
  }

  get hasEquipmentPerformanceData(): boolean {
    return this.ocrEquipmentReading !== '' || this.equipmentAvailability !== '';
  }

  get flowPerTrack(): FlowPerTrack[] {
    return this.data?.flowPerTrack ?? [];
  }

  get hasFlowPerTrack(): boolean {
    return this.flowPerTrack.length > 0;
  }

  get shouldCenterSummaryCard(): boolean {
    const groupId = this.data?.groupId;

    return !groupId || [
      GroupEnum.SERRA_GAUCHA,
      GroupEnum.VIA_ARAUCARIA,
      GroupEnum.SANTAMARIA,
      GroupEnum.PRF
    ].includes(groupId);
  }

  toggleFlowPerTrack() {
    this.showFlowPerTrack = !this.showFlowPerTrack;
  }

  openEquipmentLocation(): void {
    this.locationClick.emit(this.data);
  }

  getTextColor(min: any, med: any, alt: any, max: any, value: any) {
    if (value <= min) {
      this.taxa = 'Baixo';
      return 'color: #54a005';
    } else if (value <= med && value > min) {
      this.taxa = 'Médio';
      return 'color: #aacc00';
    }else if(value <= alt && value > med){
      this.taxa = 'Alto';
      return 'color: #d3c203';
    }else{
      this.taxa = 'Congestionado';
      return 'color: #54a005';
    }
  }
}
